export const ALLOWED_PARTNER_ID = "2000219863";
export const NAFDAQ_SIGNUP_URL = "https://signup-nafdak.godocm.com/";
export const DEFAULT_SIGNUP_URL = "https://signup.godocm.com";
export const MOROCCO_SIGNUP_URL =
  "https://signup-ma.godocm.com/?rm=101&utm_medium=godoweb_ma";

export const UNAUTHORIZED_PARTNER_MESSAGE =
  "Access denied. This portal is only available for the authorized partner.";

export function isNafdaqLoginHost(hostname = window.location.hostname) {
  return String(hostname || "").toLowerCase().includes("nafdak");
}

export function getLoginSignupUrl({ countryCode } = {}) {
  if (isNafdaqLoginHost()) {
    return NAFDAQ_SIGNUP_URL;
  }
  if (countryCode === "MA") {
    return MOROCCO_SIGNUP_URL;
  }
  return DEFAULT_SIGNUP_URL;
}

export function getProfilePartnerId(profile) {
  return profile?.user?.parentId ?? profile?.parentId ?? null;
}

export function isAllowedPartner(profile) {
  const partnerId = getProfilePartnerId(profile);
  return partnerId != null && String(partnerId) === String(ALLOWED_PARTNER_ID);
}
